import React from "react";
import { Page } from "../../components/page/page";
import styles from "./element-of-nature.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setElementOfNature, setRelationshipStatus } from "../../store/stateSlice";

const options = [
  {
    value: "Earth",
    icon: "🌍",
    link: "../traits",
  },
  {
    value: "Water",
    icon: "🌊",
    link: "../traits",
  },
  {
    value: "Fire",
    icon: "🔥",
    link: "../traits",
  },
  {
    value: "Air",
    icon: "🌪️",
    link: "../traits",
  },
];

const ElementOfNaturePage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Which element of nature do you feel most connected to?"
      hideContinueButton={true}
      currentStep={8}
    >
      <p className={styles.text}>Your connection to an element helps personalize your horoscope insights</p>
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to={option.link}
              onClick={() => dispatch(setElementOfNature(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { ElementOfNaturePage };
